import {
  Globe,
  Pen,
  Logs,
  ClipboardList,
  BetweenHorizontalEnd,
  Split,
  BetweenHorizontalStart,
  Signpost,
  Boxes,
  RotateCcw,
  ArrowUpDown,
  ListFilter,
  Code,
  FunctionSquare,
  Workflow,
  // OctagonX,
} from "lucide-react";

export const logicNodes: {
  type: string;
  header: string;
  nodeDescription: string;
  borderColor: string;
  shadowColor: string;
  iconStyle?: string | "";
  icon: React.ComponentType<any>;
}[] = [
  {
    type: "ifElseNode",
    header: "If Else",
    nodeDescription: "Route items to different branches (true/false)",
    borderColor: "var(--node-ifelse)",
    shadowColor: "var(--node-shadow-ifelse)",
    icon: Split,
    iconStyle: "text-muted-foreground rotate-90",
  },
  {
    type: "switchNode",
    header: "Switch",
    nodeDescription: "Route items depending on defined expression or rules",
    borderColor: "var(--node-switch)",
    shadowColor: "var(--node-shadow-switch)",
    icon: Signpost,
    iconStyle: "text-muted-foreground",
  },
  {
    type: "loopOverItemsNode",
    header: "Loop Over Items",
    nodeDescription: "Split data into batches and iterate over each batch",
    borderColor: "var(--node-loop-over)",
    shadowColor: "var(--node-shadow-loop-over)",
    icon: RotateCcw,
    iconStyle: "text-muted-foreground",
  },
  //  NEEDED IN THE FUTURE
  // {
  //   type: "stopAndErrorNode",
  //   header: "Stop and Error",
  //   nodeDescription: "Stop the workflow and throw an error",
  //   borderColor: "var(--node-error)",
  //   shadowColor: "var(--node-shadow-error)",
  //   icon: OctagonX,
  //   iconStyle: "text-muted-foreground",
  // },
];

export const dataTransmission: {
  type: string;
  header: string;
  nodeDescription: string;
  borderColor: string;
  shadowColor: string;
  iconStyle?: string | "";
  icon: React.ComponentType<any>;
}[] = [
  {
    type: "editFields",
    header: "Edit Fields",
    nodeDescription: "Modify, add, or remove item fields",
    borderColor: "var(--node-edit)",
    shadowColor: "var(--node-shadow-edit)",
    icon: Pen,
    iconStyle: "text-muted-foreground",
  },
  {
    type: "splitOutNode",
    header: "Split Out",
    nodeDescription: "Turn a list inside items(s) into separate items",
    borderColor: "var(--node-splitout)",
    shadowColor: "var(--node-shadow-splitout)",
    icon: BetweenHorizontalStart,
    iconStyle: "text-muted-foreground",
  },
  {
    type: "aggregateNode",
    header: "Aggregate",
    nodeDescription:
      "combine a field from many items into a list a single item",
    borderColor: "var(--node-aggregate)",
    shadowColor: "var(--node-shadow-aggregate)",
    icon: BetweenHorizontalEnd,
    iconStyle: "text-muted-foreground",
  },
  {
    type: "mergeNode",
    header: "Merge",
    nodeDescription:
      "merges data of multiple streams once data from both is available",
    borderColor: "var(--node-merge)",
    shadowColor: "var(--node-shadow-merge)",
    icon: Boxes,
    iconStyle: "text-muted-foreground rotate-90",
  },
  {
    type: "sortNode",
    header: "Sort",
    nodeDescription: "change items order",
    borderColor: "var(--node-sort)",
    shadowColor: "var(--node-shadow-sort)",
    icon: ArrowUpDown,
    iconStyle: "text-muted-foreground",
  },
  {
    type: "limitNode",
    header: "Limit",
    nodeDescription: "Restrict the number of items",
    borderColor: "var(--node-limit)",
    shadowColor: "var(--node-shadow-limit)",
    icon: ListFilter,
    iconStyle: "text-muted-foreground",
  },
];

export const customNodes: {
  type: string;
  header: string;
  nodeDescription: string;
  borderColor: string;
  shadowColor: string;
  iconStyle?: string | "";
  icon: React.ComponentType<any>;
}[] = [
  {
    type: "requestBlock",
    header: "HTTP Request",
    nodeDescription: "Makes an HTTP request and returns the response data",
    borderColor: "var(--node-request)",
    shadowColor: "var(--node-shadow-request)",
    icon: Globe,
    iconStyle: "text-muted-foreground",
  },
  {
    type: "connectFlow",
    header: "Connect Flow",
    nodeDescription:
      "Helpers for calling other Meshx workflows. Used for designing modular, microservice-like workflows.",
    borderColor: "var(--node-connect-flow)",
    shadowColor: "var(--node-shadow-connect-flow)",
    icon: Workflow,
    iconStyle: "text-muted-foreground",
  },
];

export const lsNodes: {
  type: string;
  header: string;
  nodeDescription: string;
  borderColor: string;
  shadowColor: string;
  iconStyle?: string | "";
  icon: React.ComponentType<any>;
}[] = [
  {
    type: "savelogs",
    header: "Save Logs",
    nodeDescription: "LinkShadow Log Management Node",
    borderColor: "var(--primary-green)",
    shadowColor: "var(--node-shadow-savelogs)",
    icon: Logs,
    iconStyle: "text-muted-foreground",
  },
  {
    type: "savedatalist",
    header: "Datalist",
    nodeDescription: "LinkShadow Data List Management Node",
    borderColor: "var(--primary-amber)",
    shadowColor: "var(--node-shadow-savedatalist)",
    icon: ClipboardList,
    iconStyle: "text-muted-foreground",
  },
  {
    type: "functionNode",
    header: "Function",
    nodeDescription:
      "LinkShadow predefined functions are available through the Function Node.",
    borderColor: "var(--node-function)",
    shadowColor: "var(--node-shadow-function)",
    icon: FunctionSquare,
    iconStyle: "text-muted-foreground",
  },
];

export const codeNodes: {
  type: string;
  header: string;
  nodeDescription: string;
  borderColor: string;
  shadowColor: string;
  iconStyle?: string | "";
  icon: React.ComponentType<any>;
  permission?: "isAdmin" | "isUser" | undefined;
}[] = [
  {
    type: "pythonCodeNode",
    header: "Python Code",
    nodeDescription: "Run custom Python code",
    borderColor: "var(--node-python)",
    shadowColor: "var(--node-shadow-python)",
    icon: Code,
    iconStyle: "text-muted-foreground",
    permission: "isAdmin",
  },
];
